var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('HeaderBar'),_c('div',{staticClass:"columns is-gapless"},[_c('div',{staticClass:"column is-narrow is-hidden-mobile has-background-black-ter"},[_c('SideBar')],1),_c('div',{staticClass:"column"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }